import { type PropsWithChildren, type ReactNode, useCallback } from "react";

type Props = {
	title: string;
	icon: ReactNode;
	open?: boolean;
	editable?: boolean;
	onEdit?: () => void;
};

export const Frame: React.FC<PropsWithChildren<Props>> = ({
	icon,
	title,
	children,
	editable = false,
	open = false,
	onEdit,
}) => {
	const handleEditClick = useCallback(() => {
		onEdit && onEdit();
	}, [onEdit]);

	return (
		<div>
			<div className="flex-1">
				<div className="bg-gpa-blue-50/40">
					<div className="flex gap-3 p-3 bg-white">
						{icon}
						<h1 className="font-bold">{title}</h1>
						{editable ? (
							<button
								type="button"
								className="text-gpa-blue-500 ml-auto"
								onClick={handleEditClick}
							>
								Editar
							</button>
						) : null}
					</div>
					{open ? <div className="flex flex-col p-4">{children}</div> : null}
				</div>
			</div>
		</div>
	);
};
